import axios from 'axios';
import { BASE_URL } from './apiconfig';
import User from '../../redux/models/user.model';

export const getDealerships = async (token: string | null, params:string) => {
  try {
    const { data } = await axios.get(`${BASE_URL}/dealerships?${params}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return data;
  } catch (error) {
    console.log("Failed to pull dealerships list. ", error);
    throw error;
  }
}

export const getAllDealerships = async (token: string | null, params:string) => {
  try {
    const { data } = await axios.get(`${BASE_URL}/dealerships/all?${params}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return data;
  } catch (error) {
    console.log("Failed to pull all dealerships. ", error);
    throw error;
  }
}

export const getDealership = async (token: string | null, id: string) => {
  try {
    const { data } = await axios.get(`${BASE_URL}/dealerships/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    return data;
  } catch (error) {
    console.log("Failed to pull dealership by id. ", error);
    throw error;
  }
}

export const getDealershipUsers = async (token: string | null, getInfo:{id:string, params:string}) => {
  try {
    const { data } = await axios.get(`${BASE_URL}/dealerships/${getInfo.id}/users?${getInfo.params}`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    return data;
  } catch (error) {
    console.log("Failed to pull dealership users. ", error);
    throw error;
  }
}

export const getDealershipStaff = async (token: string | null, getInfo:{id:string, params:string}) => {
  try {
    const { data } = await axios.get(`${BASE_URL}/dealerships/${getInfo.id}/staff?${getInfo.params}`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    return data;
  } catch (error) {
    console.log("Failed to pull dealership staff. ", error);
    throw error;
  }
}

export const storeDealership = async (token: string | null, 
  dealership:{
    name?:string;
    city?:string;
    phone?:string;
    email?:string;
    website_url?:string;
    supplies_url?:string;
    region_id?:string;
    country_id?:string;
  }) => {
    try {
      const { data } = await axios.post(`${BASE_URL}/admin/dealerships`,
        dealership,
      {
        headers: { Authorization: `Bearer ${token}` },
      });
  
      return data;
    } catch (error) {
      console.log("Failed to create dealership. ", error);
      throw error;
    }
  }

export const updateDealershipApi = async (token: string | null,
  id:string,
  dealership:{
    name?:string;
    city?:string;
    phone?:string;
    email?:string;
    website_url?:string;
    supplies_url?:string;
    region_id?:string;
    country_id?:string;
  }) => {
  try {
    const { data } = await axios.put(`${BASE_URL}/dealerships/${id}`,
        dealership,
        {
          headers: { Authorization: `Bearer ${token}` },
        });

    return data;
  } catch (error) {
    console.log("Failed to update dealership. ", error);
    throw error;
  }
}


export const destroyDealership = async (token: string | null, id: string) => {
  try {
    const { data } = await axios.delete(`${BASE_URL}/admin/dealerships/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    return data;
  } catch (error) {
    console.log("Failed to delete dealership. ", error);
    throw error;
  }
}

export const getCorporateUsers = async (token: string | null, params:string) => {
    try {
        const { data } = await axios.get(`${BASE_URL}/admin/users/corporate-users?${params}`, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return data;
    } catch (error) {
        console.log("Failed to pull list of users. ", error);
        throw error;
    }
}

export const assignCorporateUserApi = async (token: string | null, assignInfo: {id: string, user_id:string}) => {
    try {
        const { data } = await axios.put(`${BASE_URL}/admin/dealerships/${assignInfo.id}/assign-corporate`,
        {user_id: assignInfo.user_id},
        {
            headers: { Authorization: `Bearer ${token}` },
        });
        return data;
    } catch (error) {
        console.log("Failed to update corporate user. ", error);
        throw error;
    }
}

